var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPortfolio = function SvgPortfolio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D1D6",
    d: "M14.371 2.653h-3.195V.607A.62.62 0 0 0 10.547 0H4.453a.616.616 0 0 0-.63.607v2.046H.63A.62.62 0 0 0 0 3.26v10.133A.62.62 0 0 0 .629 14H14.37a.62.62 0 0 0 .629-.607V3.26a.62.62 0 0 0-.629-.607m-8.767-.935h3.792v.935H5.604zm7.61 10.558H1.78V4.377h11.434z"
  })));
};
export default SvgPortfolio;